module.exports = __webpack_public_path__ + "svg_80x80/connect.0cb6b1.svg";